/**
 * CPF / CNPJ utilities — strip non-digits, format with masks and lightweight validation.
 * Brazilian standard:
 *   CPF  →  000.000.000-00  (11 digits)
 *   CNPJ →  00.000.000/0000-00  (14 digits)
 */

export const digitsOnly = (value) => String(value || '').replace(/\D/g, '');

export const maskCpf = (raw) => {
  const d = digitsOnly(raw).slice(0, 11);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
  if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9, 11)}`;
};

export const maskCnpj = (raw) => {
  const d = digitsOnly(raw).slice(0, 14);
  if (d.length <= 2) return d;
  if (d.length <= 5) return `${d.slice(0, 2)}.${d.slice(2)}`;
  if (d.length <= 8) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}`;
  if (d.length <= 12) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8)}`;
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12, 14)}`;
};

export const maskDoc = (raw, tipo) => {
  if (tipo === 'pj') return maskCnpj(raw);
  return maskCpf(raw);
};

export const detectDocTipo = (raw) => {
  const d = digitsOnly(raw);
  if (d.length > 11) return 'pj';
  return 'pf';
};

export const isValidDoc = (raw, tipo) => {
  const d = digitsOnly(raw);
  if (!d) return true; // optional — empty is OK
  if (tipo === 'pf') return d.length === 11;
  if (tipo === 'pj') return d.length === 14;
  return d.length === 11 || d.length === 14;
};

export const docTipoLabel = {
  pf: 'CPF',
  pj: 'CNPJ',
};
